import styled from 'styled-components';

export const ListWrapper = styled.div`
  .list-permissions {
    &-title {
      padding: 21px 16px;
      background: var(--light-primary);
    }
    &-panel-item {
      padding: 12px 16px;
      background: #f9f9fa;
    }
  }
  .ant-collapse-content {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .ant-collapse-content-box {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    padding: 0 !important;
  }
  .ant-collapse-item {
    margin-bottom: 0px;
  }
  .ant-divider-horizontal {
    min-width: unset;
    margin-right: 5px;
  }
  .ant-divider {
    margin: 4px 0;
  }
  .icon-panel {
    margin-right: 10px;
  }
`;
